import { ca } from '@cian/analytics';

export function trackBuilderCardLinkClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingLayout',
    action: 'click_sopr',
    label: 'to_card_builder',
  });
}
